var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 960.0 720.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l960.0 0l0 720.0l-960.0 0l0 -720.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l960.0 0l0 720.0l-960.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m159.55626 479.71912c-61.91767 -146.16422 -2.7921448 -313.68286 139.05849 -393.99033c141.85062 -80.30748 323.75195 -49.24409 427.81732 73.05859c104.06537 122.30267 98.98773 299.0511 -11.9422 415.69803c-110.92993 116.64697 -294.34 138.1004 -431.36572 50.456726l185.0622 -264.94214z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m159.55626 479.71912c-61.91767 -146.16422 -2.7921448 -313.68286 139.05849 -393.99033c141.85062 -80.30748 323.75195 -49.24409 427.81732 73.05859c104.06537 122.30267 98.98773 299.0511 -11.9422 415.69803c-110.92993 116.64697 -294.34 138.1004 -431.36572 50.456726",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 24,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeDasharray: "72.0,96.0,0.0,96.0",
    d: "m159.55626 479.71912c-61.91767 -146.16422 -2.7921448 -313.68286 139.05849 -393.99033c141.85062 -80.30748 323.75195 -49.24409 427.81732 73.05859c104.06537 122.30267 98.98773 299.0511 -11.9422 415.69803c-110.92993 116.64697 -294.34 138.1004 -431.36572 50.456726",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m690.57446 492.8726l0 0c-117.88452 92.40115 -280.7894 81.43741 -363.85825 -24.48819c-83.06885 -105.9256 -54.845154 -266.70123 63.039368 -359.10236l0 0c-47.88913 99.49772 -38.71048 211.0344 23.94101 290.9247c62.65149 79.89032 168.8028 115.417206 276.87787 92.66583z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 24,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m690.57446 492.8726l0 0c-117.88452 92.40115 -280.7894 81.43741 -363.85825 -24.48819c-83.06885 -105.9256 -54.845154 -266.70123 63.039368 -359.10236l0 0c-47.88913 99.49772 -38.71048 211.0344 23.94101 290.9247c62.65149 79.89032 168.8028 115.417206 276.87787 92.66583z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIMoon);
export default __webpack_public_path__ + "static/media/IMoon.c3e1fba65035aff38263545db8dfb2c7.svg";
export { ForwardRef as ReactComponent };